<div class="piece-marquee-render">
  <idt-common-styles-render
    *ngIf="piece"
    [styles]="piece.settings?.styles">
    @let orientation = orientation$ | async;
    <ng-container
>
        <main class="page-content">
          <section class="container">
            <div class="marquee">
              <div class="inner">
                <div
                *ngIf="settings?.general?.field01 || settings?.general?.image01"
                class="item">
                  <render-wysiwyg
                    *ngIf="settings?.general?.field01"
                    [html]="settings?.general?.field01"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece"
                    class="gap">
                  </render-wysiwyg>
                  <div
                    *ngIf="settings?.general?.image01"
                    [class.imgMarquee]="settings?.general?.image01"
                    [class.img01]="settings?.general?.image01"
                    [class.gap]="settings?.general?.gap">
                  </div>
                </div>
                <div
                  *ngIf="settings?.general?.field02 || settings?.general?.image02"
                  class="item">
                  <render-wysiwyg
                    *ngIf="settings?.general?.field01"
                    [html]="settings?.general?.field02"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece"
                    class="gap">
                  </render-wysiwyg>
                  <div
                    *ngIf="settings?.general?.image02"
                    [class.imgMarquee]="settings?.general?.image02"
                    [class.img02]="settings?.general?.image02"
                    [class.gap]="settings?.general?.gap">
                  </div>
                </div>
                <div
                  *ngIf="settings?.general?.field03 || settings?.general?.image03"
                  class="item">
                  <render-wysiwyg
                    *ngIf="settings?.general?.field03"
                    [html]="settings?.general?.field03"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece"
                    class="gap">
                  </render-wysiwyg>
                  <div
                    *ngIf="settings?.general?.image03"
                    [class.imgMarquee]="settings?.general?.image03"
                    [class.img03]="settings?.general?.image03"
                    [class.gap]="settings?.general?.gap">
                  </div>
                </div>
                <div
                  *ngIf="settings?.general?.field04 || settings?.general?.image04"
                  class="item">
                  <render-wysiwyg
                    *ngIf="settings?.general?.field04"
                    [html]="settings?.general?.field04"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece"
                    class="gap">
                  </render-wysiwyg>
                  <div
                    *ngIf="settings?.general?.image04"
                    [class.imgMarquee]="settings?.general?.image04"
                    [class.img04]="settings?.general?.image04"
                    [class.gap]="settings?.general?.gap">
                  </div>
                </div>
                <div
                  *ngIf="settings?.general?.field05 || settings?.general?.image05"
                  class="item">
                  <render-wysiwyg
                    *ngIf="settings?.general?.field05"
                    [html]="settings?.general?.field05"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece"
                    class="gap">
                  </render-wysiwyg>
                  <div
                    *ngIf="settings?.general?.image05"
                    [class.imgMarquee]="settings?.general?.image05"
                    [class.img05]="settings?.general?.image05"
                    [class.gap]="settings?.general?.gap">
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
    </ng-container>
  </idt-common-styles-render>
</div>
